// /topic/risk-halt 구독 — 화면 14 전용.
// 권위: ARCH_DASHBOARD.md v1.8 §4.14 / §6.3 (ADR-DASH-04 — 신설 토픽).
// ADR-RISK-07 — 변동성 지수 트리거 폐기. 관련 PORTFOLIO 분기 제거.
//
// 수신 이벤트 (ARCH_OBSERVABILITY §4.2):
//   RISK.HALT.TRIGGERED              (FATAL)
//   RISK.HALT.RECOVERED              (INFO)
//   RISK.HALT.STATE                  (INFO, 1분 헬스 비콘 — 선택)
//   RISK.POSITION.LIQUIDATION_REQUESTED (WARN)
//   PORTFOLIO.LOSS.THRESHOLD_BREACHED / RECOVERED

import { useEffect } from 'react';
import type { IMessage } from '@stomp/stompjs';
import { subscribe } from './useWebSocket';

export interface RiskHaltEvent {
  event_code: string;
  event_id?: string;
  occurred_at?: string;
  severity?: string;
  trace_id?: string;
  payload?: Record<string, unknown>;
}

function normalize(raw: unknown): RiskHaltEvent | null {
  if (!raw || typeof raw !== 'object') return null;
  const obj = raw as Record<string, unknown>;
  const code = (obj.event_code ?? obj.eventCode) as string | undefined;
  if (!code || typeof code !== 'string') return null;
  return {
    event_code: code,
    event_id: (obj.event_id ?? obj.eventId) as string | undefined,
    occurred_at: (obj.occurred_at ?? obj.occurredAt) as string | undefined,
    severity: obj.severity as string | undefined,
    trace_id: (obj.trace_id ?? obj.traceId) as string | undefined,
    payload: (obj.payload ?? undefined) as Record<string, unknown> | undefined,
  };
}

export function useRiskHalt(handler: (event: RiskHaltEvent) => void): void {
  useEffect(() => {
    const unsub = subscribe('/topic/risk-halt', (msg: IMessage) => {
      let parsed: unknown;
      try {
        parsed = JSON.parse(msg.body);
      } catch {
        return;
      }
      const ev = normalize(parsed);
      if (!ev) return;
      try {
        handler(ev);
      } catch {
        /* 핸들러 예외는 무시. */
      }
    });
    return unsub;
  }, [handler]);
}
